// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30HSk","content":"styles_content__17dCP","tableWrap":"styles_tableWrap__lcivF"};